import { useState, useEffect, useContext } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import AIAnswerViewModel from "../ViewModels/AIAnswerViewModel";

export enum AIAnswerActions {
    getVocAnswers = 'GetVoiceOfTheCustomerAnswers',
    getSalesAnswers = 'GetSalesAnswers',
    getGuideAnswers = 'GetGuideAnswers',
    getInsightAnswers = 'GetInsightAnswers',

}

export default function useAIAnswers(id: string, action: AIAnswerActions, enabled: boolean = true) {
    const { get } = useContext(APIContext);
    const [answers, setAnswers] = useState<AIAnswerViewModel[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        //when disabled the tab is still shown but disabled, so skip the fetch rather than gating the hook call
        if (enabled) {
            getAnswers(id);
        }
        else {
            setAnswers(null);
            setIsLoading(false);
        }
    }, [id, enabled])

    const getAnswers = (id: string) => {
        setAnswers(null);
        setIsLoading(true);
        get('AIAnalysis',
            `${action}?switchCallId=${id}`,
            (data) => {
                setAnswers(data);
                setIsLoading(false);
            }, () => {
                setAnswers(null);
                setIsLoading(false);
            })
    }

    return { answers, isLoading };
}